module.exports = __webpack_public_path__ + "img/2.bc6208a8.jpg";